import { Api } from "../../Config/Request";
export const requestchat = async (data) => {
  return Api.PostRequest( 
    "https://worx-assistant-function-app.azurewebsites.net/api/queryAssistantProxy",
    data,
    true
  );
};
export const requestasynmsg = async (data) => {
  return Api.PostRequest( 
  "https://worx-assistant-async-function-app.azurewebsites.net/api/queryAssistantProxyStream",
  data,
  true
);
};
export const requestlogo = async (data) => {
  return Api.GetRequest(`identify?clientKey=${data.key}&default_lang=${data.default_lang}`);
};
const ApiRequests = {
  requestchat,
  requestlogo,
  requestasynmsg
};
export default ApiRequests;
